import Vue from 'vue'

import moment from '@/utils/moment'

export const DATE_FORMAT = 'D MMMM YYYY'
export const DATE_TIME_FORMAT = 'HH:mm D MMMM YYYY'
export const DATE_TIME_SECONDS_FORMAT = 'HH:mm:ss D MMMM YYYY'

export const formatDate = value => (value ? moment(value).format(DATE_FORMAT) : '???')

export const formatDateTime = value => (value ? moment(value).format(DATE_TIME_FORMAT) : '???')

export const formatDateTimeSeconds = value => (value ? moment(value).format(DATE_TIME_SECONDS_FORMAT) : '???')

export const formatEntryNumberLabel = value => (value === 1 ? `${value} Entry` : `${value} Entries`)

export const formatPrice = value => Number(value).toFixed(2)

export const formatPhoneNumber07 = value => (value.startsWith('44') ? `0${value.substring(2)}` : value)

export const formatPhoneNumber44 = value => (value.startsWith('07') ? `44${value.substring(1)}` : value)

export const shortLink = value => {
  try {
    const newUrl = new URL(value)
    return newUrl.href.replace(/^https:\/\/(?:www.)?/, '').replace(/\/+$/, '')
  } catch {
    return ''
  }
}

Vue.filter('date', value => formatDate(value))
Vue.filter('dateTime', value => formatDateTime(value))
Vue.filter('dateTimeSeconds', value => formatDateTimeSeconds(value))
Vue.filter('entryNumberLabel', value => formatEntryNumberLabel(value))
Vue.filter('price', value => formatPrice(value))
Vue.filter('phoneNumber07', value => formatPhoneNumber07(value))
Vue.filter('phoneNumber44', value => formatPhoneNumber44(value))
Vue.filter('shortLink', value => shortLink(value))
